import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Changelog } from './changelog';

@Injectable({
    providedIn: 'root',
})
export class ChangelogService {
    constructor(private http: HttpClient) {}

    /**
     * Get all changelogs
     */
    getAllChangelogs(): Observable<Changelog[]> {
        return this.http.get<Changelog[]>(`${environment.appApi}/changelogs`);
    }

    /**
     * Get changelogs filtered by area
     * @param area 1 = Recent Changes, 2 = Upcoming Features
     */
    getChangelogsByArea(area: number): Observable<Changelog[]> {
        return this.http.get<Changelog[]>(`${environment.appApi}/changelogs/area/${area}`);
    }

    /**
     * Get a specific changelog by ID
     * @param id Changelog ID
     */
    getChangelogById(id: number): Observable<Changelog> {
        return this.http.get<Changelog>(`${environment.appApi}/changelogs/${id}`);
    }
}
